/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landskin_10_DescriptionInputs */

const en_landskin_10_description = /** @type {(inputs: Landskin_10_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soft ground dotted with autumn leaves wraps your forest in cozy warmth.`)
};

const ar_landskin_10_description = /** @type {(inputs: Landskin_10_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أرض ناعمة تتناثر عليها أوراق الخريف تغمر الغابة بدفء مريح.`)
};

const de_landskin_10_description = /** @type {(inputs: Landskin_10_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weicher Boden mit verstreuten Herbstblättern hüllt deinen Wald in gemütliche Wärme.`)
};

const es_landskin_10_description = /** @type {(inputs: Landskin_10_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un suelo mullido salpicado de hojas otoñales envuelve tu bosque en una calidez acogedora.`)
};

const fr_landskin_10_description = /** @type {(inputs: Landskin_10_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un sol moelleux parsemé de feuilles d’automne enveloppe votre forêt d’une douce chaleur.`)
};

const it_landskin_10_description = /** @type {(inputs: Landskin_10_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un terreno soffice punteggiato di foglie autunnali avvolge la tua foresta in un calore accogliente.`)
};

const ja_landskin_10_description = /** @type {(inputs: Landskin_10_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`落ち葉が彩るふかふかの大地が、マイフォレストを心地よいぬくもりで包みます。`)
};

const ko_landskin_10_description = /** @type {(inputs: Landskin_10_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가을잎이 내려앉은 폭신한 땅이 나의 숲을 포근한 온기로 감싸 줍니다.`)
};

const pt_br_landskin_10_description = /** @type {(inputs: Landskin_10_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um chão macio salpicado de folhas de outono envolve sua floresta em um calor aconchegante.`)
};

const ru_landskin_10_description = /** @type {(inputs: Landskin_10_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мягкая земля, украшенная осенними листьями, окутывает ваш лес уютным теплом.`)
};

const th_landskin_10_description = /** @type {(inputs: Landskin_10_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พื้นนุ่มที่แต่งแต้มด้วยใบไม้ร่วงโอบกอดป่าของคุณด้วยความอบอุ่นแสนสบาย`)
};

const tr_landskin_10_description = /** @type {(inputs: Landskin_10_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonbahar yapraklarıyla bezeli yumuşacık zemin, ormanını sıcacık sarar.`)
};

const zh_cn_landskin_10_description = /** @type {(inputs: Landskin_10_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`让秋叶点缀柔软林地，为森林铺上一床暖意。`)
};

const zh_tw_landskin_10_description = /** @type {(inputs: Landskin_10_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`讓秋葉點綴柔軟林地，為森林鋪上一床暖意。`)
};

/**
* | output |
* | --- |
* | "Soft ground dotted with autumn leaves wraps your forest in cozy warmth." |
*
* @param {Landskin_10_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const landskin_10_description = /** @type {((inputs?: Landskin_10_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landskin_10_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landskin_10_description(inputs)
	if (locale === "ar") return ar_landskin_10_description(inputs)
	if (locale === "de") return de_landskin_10_description(inputs)
	if (locale === "es") return es_landskin_10_description(inputs)
	if (locale === "fr") return fr_landskin_10_description(inputs)
	if (locale === "it") return it_landskin_10_description(inputs)
	if (locale === "ja") return ja_landskin_10_description(inputs)
	if (locale === "ko") return ko_landskin_10_description(inputs)
	if (locale === "pt_br") return pt_br_landskin_10_description(inputs)
	if (locale === "ru") return ru_landskin_10_description(inputs)
	if (locale === "th") return th_landskin_10_description(inputs)
	if (locale === "tr") return tr_landskin_10_description(inputs)
	if (locale === "zh_cn") return zh_cn_landskin_10_description(inputs)
	return zh_tw_landskin_10_description(inputs)
});